import { apiClient } from '../utils/apiClient';

export const authService = {
  login: async (username: string, password: string) => {
    try {
      const response = await apiClient.post('/api/v1/users/login', { username, password });
      return response.data;
    } catch (error) {
      // Fallback for development/testing if API is not available
      if (username === '2545' && password === '123456789') {
        console.warn('Using fallback authentication - connect to real API in production');
        return {
          id: '1',
          username: '2545',
          role: 'admin',
          token: 'demo-jwt-token-' + Date.now()
        };
      }
      throw new Error('Authentication failed');
    }
  },
  
  validateToken: async (token: string) => {
    try {
      const response = await apiClient.post('/api/v1/users/validate-token', { token });
      return response.data.valid;
    } catch (error) {
      // Fallback for development/testing if API is not available
      console.warn('Using fallback token validation - connect to real API in production');
      return true;
    }
  },
  
  refreshToken: async (token: string) => {
    try {
      const response = await apiClient.post('/api/v1/users/refresh-token', { token });
      return response.data;
    } catch (error) {
      // Fallback for development/testing if API is not available
      console.warn('Using fallback token refresh - connect to real API in production');
      return {
        token: 'demo-jwt-token-refreshed-' + Date.now()
      };
    }
  }
};
